import { call, takeLatest, all, put } from 'redux-saga/effects';
import api from 'services/api';
import { Types, Creators } from 'store/ducks/attachment/insert';
// import { callApi } from 'store/sagas/auth';

import { push } from 'connected-react-router';
import Notifications from 'react-notification-system-redux';

function* getInsertAttachment({ payload }) {
  try {
    const {
      name,
      slug,
      file,
      description,
      activity_id,
      moduleId,
      // link,
      status,
      viaModule,
    } = payload;

    if (viaModule) {
      const data = new FormData();
      data.append('name', name);
      data.append('file', file);
      data.append('description', description.toString('markdown'));
      data.append('status', status);
      const response = yield call(
        api.post,
        `/v1/admin/attachments/files`,
        data,
      );
      // const response2 = yield call(
      //   api.post,
      //   `/v1/admin/modules/${moduleId}/files/${response.data.data.id}`,
      // );
      yield put(Creators.getAttachmentInsertSuccess(response.data));
      yield put(push(`/modulos/${moduleId}/anexos`));
      yield put(
        Notifications.success({ title: 'Cadastro concluido com sucesso' }),
      );
    } else {
      const data = new FormData();
      data.append('name', name);
      data.append('slug', slug);
      data.append('file', file);
      data.append('description', description.toString('markdown'));
      data.append('activity_id', activity_id);
      data.append('status', 1);
      const response = yield call(
        api.post,
        `/v1/admin/attachments/files`,
        data,
      );
      yield put(Creators.getAttachmentInsertSuccess(response.data));
      yield put(push(`/modulos/${moduleId}/atividades/${activity_id}/anexos`));
      yield put(
        Notifications.success({ title: 'Cadastro concluido com sucesso' }),
      );
    }
  } catch (err) {
    yield put(Creators.getAttachmentInsertFailure('Erro ao buscar na API'));
  }
}

export default function* attachmentSaga() {
  yield all([takeLatest(Types.GET_INSERT_REQUEST, getInsertAttachment)]);
}
